import postApiRequest from "shared/api/postApiRequest";

export const checkFileExist = async (filename) => {
  const response = await postApiRequest("/api/slides/check-file/", { filename });

  return !!response?.data?.exists;
};
